export default "__VITE_PUBLIC_ASSET__3438b6e5__"